module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/am605-696e66bfa723447448448a00c839ee7c.jpg";